import { useState } from 'react'

interface UuidBadgeProps { uuid: string }

/** uuid 앞 5자 뱃지 — 클릭 시 전체 uuid 클립보드 복사 + 1.2s 동안 ✓ 표시 */
export function UuidBadge({ uuid }: UuidBadgeProps) {
  const [copied, setCopied] = useState(false)
  return (
    <button type="button" className="uuid-badge"
      data-uuid={uuid}
      title={copied ? 'Copied' : `Copy uuid: ${uuid}`}
      aria-label={`Copy uuid ${uuid}`}
      onClick={(e) => {
        e.stopPropagation()
        navigator.clipboard.writeText(uuid).catch(() => {/* ignore — http context 등 */})
        setCopied(true)
        setTimeout(() => setCopied(false), 1200)
      }}>
      {copied ? '✓' : uuid.slice(0, 5)}
    </button>
  )
}
